export const NAMESPACE = 'Wix_Ads';
export const MAIN_TEXT_KEY = 'responsive_banner_text';
export const MAIN_TEXT_DEFAULT = 'Created on {X}';
export const LOGO_TEXT_KEY = 'responsive_banner_alt_text_EditorX';
export const LOGO_TEXT_DEFAULT = 'Editor X';
export const logoPlaceHolder = '{X}';
